module.exports = __webpack_public_path__ + "assets/img/beater_active.b36dfbbd.png";